import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const FinancialChart = ({ title, labels, datasets, currency }) => {
  const data = {
    labels: labels,
    datasets: datasets.map(dataset => ({
      ...dataset,
      backgroundColor: dataset.color, // Use the color from the dataset configuration
      borderColor: dataset.color,
      borderWidth: 1,
      minBarLength: 2,
    })),
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: title,
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            if (context.parsed.y !== null) {
              label += new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD' }).format(context.parsed.y);
            }
            return label;
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function(value) {
            return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD', notation: 'compact', compactDisplay: 'short' }).format(value);
          }
        }
      }
    }
  };

  return <Bar data={data} options={options} />;
};

export default FinancialChart;
